import React from "react";
import "./AddOns.css";

const Addons = () => {
  return (
    <section className="addons-section" id="addons">
      <div className="addons-container">
        <h2 className="addons-title">Add-Ons</h2>
        <p className="addons-subtitle">
          Enhance your service with these optional extras (prices by vehicle size)
        </p>

        <div className="addons-table-wrapper">
          <table className="addons-table">
            <thead>
              <tr>
                <th className="service-col">Service</th>
                <th>S</th>
                <th>M</th>
                <th>L</th>
                <th>XL</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Pet Hair Removal</td>
                <td>£25</td>
                <td>£35</td>
                <td>£45</td>
                <td>£70</td>
              </tr>
              <tr>
                <td>Heavily Soiled</td>
                <td>£15</td>
                <td>£25</td>
                <td>£35</td>
                <td>£55</td>
              </tr>
              <tr>
                <td>Interior Ceiling</td>
                <td>£35</td>
                <td>£45</td>
                <td>£55</td>
                <td>£75</td>
              </tr>
              <tr>
                <td>Engine Bay</td>
                <td>£25</td>
                <td>£35</td>
                <td>£45</td>
                <td>£60</td>
              </tr>
              <tr>
                <td>Exterior Trim Restoration</td>
                <td>£35</td>
                <td>£45</td>
                <td>£55</td>
                <td>£75</td>
              </tr>
              <tr>
                <td>Stage 2 Decontamination</td>
                <td>£35</td>
                <td>£45</td>
                <td>£55</td>
                <td>£75</td>
              </tr>
              <tr>
                <td>Stage 3 Decontamination</td>
                <td>£55</td>
                <td>£65</td>
                <td>£85</td>
                <td>£115</td>
              </tr>
              <tr>
                <td>Seats Shampoo & Extract</td>
                <td>£35</td>
                <td>£55</td>
                <td>£75</td>
                <td>£95</td>
              </tr>
            </tbody>
          </table>

          <div className="addons-footer">
            <p>Prices depend on vehicle size and overall condition.</p>
            <p>Additional charges may apply (£15 – £30).</p>
            <p className="highlight">
              Bundle Add-Ons Can Unlock Extra Discounts!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Addons;
